import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// Vite virtual module, only resolvable via the vite-plugin-pwa/client
// types (src/vite-env.d.ts), not a real file on disk.
// eslint-disable-next-line import-x/no-unresolved
import { registerSW } from 'virtual:pwa-register';
import { store } from './app/store';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
// Bootstrap Bundle JS
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

// registerType: 'autoUpdate' (vite.config.ts) only actually takes
// effect via this call - it's registerSW() itself that watches for a
// newly-installed service worker and auto-activates + reloads
// (skipWaiting + clientsClaim), not something baked into the
// generated sw.js on its own. Without ever calling this (the previous
// state: injectRegister's default 'auto' just does a bare
// .register('/sw.js'), nothing more), a new service worker would
// install and then sit in "waiting" state indefinitely, never
// actually taking over - regardless of how soon it was noticed.
// register() itself triggers an update check, so a plain reload is
// enough to pick up a new version; no polling needed.
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
